export class PatientTestResultsModel {
  testDate: Date;
  physicianName: string;
  locationName: string;
  phlebotomistName: string;
  bloodDrawnTimestamp: Date;
  resultsReturnedTimestamp: Date;
  testResults: Array<any>;
  selectedTest: any;
  moreInfoContent: any;
  hideMoreInfoGraph: boolean;

  constructor(params: any = {}) {
    this.testDate = params.testDate ? new Date(params.testDate) : null;
    this.physicianName = params.physicianName || null;
    this.locationName = params.locationName || null;
    this.phlebotomistName = params.phlebotomistName || null;
    this.bloodDrawnTimestamp = params.bloodDrawnTimestamp || null;
    this.resultsReturnedTimestamp = params.resultsReturnedTimestamp || null;
    this.testResults = params.testResults || [];
    this.selectedTest = params.selectedTest || null;
    this.moreInfoContent = params.moreInfoContent || null;
    this.hideMoreInfoGraph = params.hideMoreInfoGraph || false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/patient-test-results.model.ts